// Simple in-memory API cache (per SPA runtime)
// - TTL-based
// - De-dupes concurrent requests for the same key
const cache = new Map();

/**
 * Cache GET responses in-memory (per SPA session).
 * @param {string} key
 * @param {() => Promise<any>} fetcher
 * @param {number} ttlMs
 */
export async function cachedApiGet(key, fetcher, ttlMs = 10 * 60 * 1000) {
  const now = Date.now();
  const existing = cache.get(key);

  // Serve cached value if still valid
  if (
    existing &&
    existing.expiresAt > now &&
    Object.prototype.hasOwnProperty.call(existing, 'value')
  ) {
    return existing.value;
  }

  // De-dupe in-flight request
  if (existing && existing.expiresAt > now && existing.inFlightPromise) {
    return existing.inFlightPromise;
  }

  const inFlightPromise = (async () => {
    const value = await fetcher();
    cache.set(key, { value, expiresAt: Date.now() + ttlMs });
    return value;
  })();

  cache.set(key, { inFlightPromise, expiresAt: now + ttlMs });
  return inFlightPromise;
}

export function clearApiCache() {
  cache.clear();
}


